import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { EcoChallengeSearchModel } from '../models/eco-challenge-search.model';

export class EcoChallengeSearchApiService extends ApiService {
  static endpoint = 'eco-challenge/search';

  /**
   * @param {String|Number} order
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<EcoChallengeModel>>}
   * @public
   */
  static async post(order, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(order), data, {
      ...config,
      dataModel: EcoChallengeSearchModel,
      useVApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
